import { IntervalList } from '../constants/interval-list.constant';

import { Interval } from '../interfaces/interval.interface';

import { IntervalApi } from '../enums/interval-id.enum';

export const convertIntervalToGet = (intervalId: IntervalApi): Interval => {
  return IntervalList.find(interval => IntervalApi[interval.id] === intervalId);
};
